var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndresult({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1869 38.7649L4.44524 28.0686L17.586 5.47962C19.2554 2.60993 22.9379 1.64139 25.8031 3.31842L30.5147 6.0761C33.3787 7.75239 34.338 11.4352 32.6559 14.2957L19.6678 36.3828L7.1869 38.7649Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndresult);
export default __webpack_public_path__ + "static/media/endresult.9217e5fe81e78138fa4ee3ca07de7379.svg";
export { ForwardRef as ReactComponent };